import { render, staticRenderFns } from "./OkModal.vue?vue&type=template&id=0d394064&"
import script from "./OkModal.vue?vue&type=script&lang=js&"
export * from "./OkModal.vue?vue&type=script&lang=js&"
import style0 from "./OkModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports